var ClassificationDestinationType;
(function (ClassificationDestinationType) {
    ClassificationDestinationType["CLASSIFICATION_VALIDATION_REQUEST"] = "CLASSIFICATION_VALIDATION_REQUEST";
    ClassificationDestinationType["FOLDER"] = "FOLDER";
})(ClassificationDestinationType || (ClassificationDestinationType = {}));

export { ClassificationDestinationType };
//# sourceMappingURL=types.js.map
